import { SCREEN_SM_MAX } from "constants-lib/dimensions"
import { getWindow } from "../getWindow"

const ssrWindow = getWindow()
/**
 * Checks if the current device is a mobile device.
 * Returns true if the current device is a mobile device.
 * @returns {boolean} Returns true if the current device is a mobile device, else false.
 */

const isMobileDevice = () => {
  if (!ssrWindow) return false
  const userAgentCheck =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      ssrWindow.navigator.userAgent,
    )
  const widthCheck = ssrWindow.innerWidth <= SCREEN_SM_MAX
  return userAgentCheck || widthCheck
}
// eslint-disable-next-line max-len
export default isMobileDevice
